import { useQuery } from '@tanstack/react-query';
import { getUsrhashOptions } from 'actions/usrhash';
import { useFeature } from 'context/feature-flags';
import { isBlank } from 'utils/StringUtils';

export function useFreeShipping() {
  const featureActive = useFeature('fake_free_shipping');
  const { data } = useQuery(getUsrhashOptions({ enabled: featureActive }));

  return { fake: featureActive, isSubscribed: !isBlank(data) ? true : false };
}
